var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDynamicTimetabling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 101 101",
    style: {
      enableBackground: "new 0 0 101 101"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.2,44.3c10.2,0,18.5-8.3,18.5-18.5S88.5,7.3,78.2,7.3s-18.5,8.3-18.5,18.5C59.8,36,68,44.3,78.2,44.3z  M78.2,10.4c8.5,0,15.4,6.9,15.4,15.4s-6.9,15.4-15.4,15.4s-15.4-6.9-15.4-15.4C62.8,17.3,69.7,10.4,78.2,10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.2,30.5c2.5,0,4.6-2.1,4.6-4.6c0-2-1.2-3.7-3.1-4.4v-6.4h-3.1v6.4c-1.3,0.5-2.3,1.5-2.8,2.8H69v3.1h4.9 C74.6,29.2,76.3,30.5,78.2,30.5z M78.2,24.3c0.9,0,1.5,0.7,1.5,1.5c0,0.9-0.7,1.5-1.5,1.5c-0.9,0-1.5-0.7-1.5-1.5 S77.4,24.3,78.2,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.3,61.3H35c1.7,0,3.1-1.4,3.1-3.1V36.6c0-1.7-1.4-3.1-3.1-3.1h-6.2V32h-3.1v1.5h-9.2V32h-3.1v1.5H7.3 c-1.7,0-3.1,1.4-3.1,3.1v21.6C4.3,59.9,5.6,61.3,7.3,61.3z M7.3,58.2V42.8H35v15.4C35,58.2,7.3,58.2,7.3,58.2z M13.5,36.6v1.5h3.1 v-1.5h9.2v1.5h3.1v-1.5h6.2v3.1H7.3v-3.1H13.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 45.9,
    className: "st0",
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.6,
    y: 45.9,
    className: "st0",
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.8,
    y: 45.9,
    className: "st0",
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.9,
    y: 45.9,
    className: "st0",
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 52,
    className: "st0",
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.6,
    y: 52,
    className: "st0",
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.8,
    y: 52,
    className: "st0",
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.9,
    y: 52,
    className: "st0",
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.2,81.3h-4.6v-37h-3.1v37h-74v-17h-3.1v17H5.8c-0.9,0-1.5,0.7-1.5,1.5V89c0,2.6,2.1,4.6,4.6,4.6h83.2 c2.6,0,4.6-2.1,4.6-4.6v-6.2C96.7,82,96,81.3,95.2,81.3z M44.3,84.4h12.3v1.5H44.3V84.4z M93.7,89c0,0.9-0.7,1.5-1.5,1.5H8.9 c-0.9,0-1.5-0.7-1.5-1.5v-4.6h33.9v1.5c0,1.7,1.4,3.1,3.1,3.1h12.3c1.7,0,3.1-1.4,3.1-3.1v-1.5h33.9V89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.1,25.8h38.5v-3.1H18.1c-4.3,0-7.7,3.5-7.7,7.7h3.1C13.5,27.9,15.6,25.8,18.1,25.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.7,
    y: 75.2,
    className: "st0",
    width: 61.7,
    height: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.9,59.7c0,6.8,5.5,12.3,12.3,12.3s12.3-5.5,12.3-12.3S65,47.4,58.2,47.4S45.9,52.9,45.9,59.7z M58.2,50.5 c5.1,0,9.2,4.1,9.2,9.2S63.3,69,58.2,69S49,64.9,49,59.7C49,54.6,53.1,50.5,58.2,50.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.7,64.4c0.4,0,0.8-0.2,1.1-0.5l6.2-6.2l-2.2-2.2l-5.1,5.1l-2-2l-2.2,2.2l3.1,3.1 C55.9,64.2,56.3,64.4,56.7,64.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.2,64.4v6.2c0,0.9,0.7,1.5,1.5,1.5H35V69H24.3v-4.6H21.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.2,
    y: 69,
    className: "st0",
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.3,
    y: 69,
    className: "st0",
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.8,59.7V47.4h-3.1v10.8h-3.1v3.1h4.6C79.1,61.3,79.8,60.6,79.8,59.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.3,
    y: 38.2,
    className: "st0",
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.5,
    y: 38.2,
    className: "st0",
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.7,
    y: 38.2,
    className: "st0",
    width: 3.1,
    height: 3.1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamicTimetabling);
export default __webpack_public_path__ + "static/media/DynamicTimetabling.4802c035e3d46ce4d9d86906adac2dee.svg";
export { ForwardRef as ReactComponent };